import React, { memo, useState } from 'react';
import { Button } from 'modules/ui';
import styles from './WizardFooter.module.scss';

const WizardFooter = ({
  onNextClick,
  onPreviousClick,
  previousButtonLabel = 'Previous step',
  nextButtonLabel = 'Next step',
  hasPreviousButton = true,
}) => {
  const [previousInProgress, setPreviousInProgress] = useState(false);
  const [nextInProgress, setNextInProgress] = useState(false);

  const handlePreviousClick = () => {
    setPreviousInProgress(true);

    return onPreviousClick().finally(() => {
      setPreviousInProgress(false);
    });
  };

  const handleNextClick = () => {
    setNextInProgress(true);

    return onNextClick().finally(() => {
      setNextInProgress(false);
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.footer}>
        <div className={styles.btnContainer}>
          {hasPreviousButton && (
            <Button
              secondary
              loading={previousInProgress}
              onClick={handlePreviousClick}
              className={styles.btn}
            >
              {previousButtonLabel}
            </Button>
          )}
          <Button
            primary
            loading={nextInProgress}
            onClick={handleNextClick}
            className={styles.btn}
          >
            {nextButtonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(WizardFooter);
